const dev = {
  url: {
    API_URL: "https://conduit.9ijakids.com",
  },
};

export const Config = dev;
